// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterWrapper_wrapper__eV6+V"};